import React, {useState, useMemo, useEffect} from 'react';
import {
  Tab,
  Tabs,
  makeStyles,
  Divider,
  Typography,
  IconButton,
  Chip,
  FormControlLabel,
} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {Add, Tune, ArrowBack, Close} from '@material-ui/icons';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useLocation, Link, Switch, Route} from 'react-router-dom';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import {useForm} from 'react-hook-form';
import CollapsibleAdvancedShipping from './components/CollapsibleAdvancedShipping';
import LogisticsShippingNewAdvancedNational from './LogisticsShippingNewAdvancedNational';
import {
  useAllowOrdersOutsideDeliveryZone,
  useDataShippingAdvanced,
  useFetchShippingMethods,
  useResetState,
} from '../utils';
import {useStoreCountry} from '../../../../country/utils';
import LogisticsShippingNewAdvancedInternational from './LogisticsShippingNewAdvancedInternational';
import {useCountries} from '../../../../../modules/country/utils';
import type {ShippingAdvancedRate} from '../../../../../entities';
import FilterModalShipping from '../../logistics/components/FilterModalShipping';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: '22px',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
  subRouteHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 0),
    paddingInline: theme.spacing(2),
    backgroundColor: '#fff',
    borderLeft: '1px solid #dbdbe0',
    borderRight: '1px solid #dbdbe0',
    borderTop: '1px solid #dbdbe0',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
  },
  subRouteTitle: {
    marginLeft: theme.spacing(1),
    fontSize: '1rem',
    fontWeight: 600,
  },
  contentBackground: {
    backgroundColor: '#fcfcfd',
    padding: '0px 16px 16px 16px',
    borderRadius: '8px',
    border: `1px solid #e5e6e7`,
  },
  contentTabs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tabs: {
    width: 'fit-content',
  },
  tabButton: {
    color: colors.grey600,
    textTransform: 'none',
  },
  tabSelected: {
    color: colors.grey900,
    textTransform: 'none',
  },
  divider: {
    background: '#e8e8ed',
    width: '100%',
  },
  dividerDetails: {
    background: colors.grey400,
    width: '100%',
    marginBlock: theme.spacing(2),
  },
  newRate: {
    marginBottom: theme.spacing(1),
    width: '100%',
    border: `2px dashed ${colors.grey300}`,
    borderRadius: '8px',
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    color: colors.grey700,
    fontWeight: 400,
  },
  backgroundButton: {
    backgroundColor: colors.grey300,
    borderRadius: '50%',
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterButton: {
    background: 'transparent',
    border: '1px solid #E0E0E0',
    color: colors.grey600,
    paddingInline: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  containerDataRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  containerDataLocation: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '200px',
    overflowY: 'auto',
  },
  containerData: {
    backgroundColor: '#f9f9fb',
    borderRadius: '8px',
    padding: theme.spacing(2),
    flex: 1,
  },
  containerCollapsible: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  dataBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    border: 'none',
    gap: theme.spacing(1),
    marginTop: '1rem',
  },
  textGrey: {
    color: colors.grey600,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  textHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  buttonsHeader: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  bold: {
    fontWeight: 600,
  },
  check: {
    backgroundColor: '#ccf0e6',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    height: '19px',
    width: '19px',
    padding: '12px',
    justifyContent: 'center',
    cursor: 'pointer',

    '& svg': {
      color: '#007f5d',
      fontSize: '19px',
      fontWeight: 600,
    },
  },
  notCheck: {
    padding: '11px',
    backgroundColor: '#ffffff',
    border: '1px solid #d4d4dd',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    height: '19px',
    width: '19px',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  deleteButton: {
    color: colors.error,
    width: 'fit-content',
  },
  editButton: {
    color: colors.grey600,
  },
  chipCountry: {
    backgroundColor: colors.grey300,
    color: colors.grey700,
    padding: theme.spacing(1),
    borderRadius: '8px',
    width: 'fit-content',
    fontWeight: 600,
    height: '25px',
    textTransform: 'uppercase',
  },
  chipCountryNotFound: {
    backgroundColor: colors.error,
    color: 'white',
    padding: theme.spacing(1),
    borderRadius: '8px',
    width: 'fit-content',
    fontWeight: 600,
    height: '25px',
    textTransform: 'uppercase',
  },
  textZone: {
    fontSize: '1rem',
    fontWeight: 600,
    paddingBottom: theme.spacing(2),
  },
  delivery: {
    backgroundColor: '#fff',
    border: '1px solid #dbdbe0',
    borderRadius: '8px',
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  containerHeaderDelivery: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textGrey2: {
    color: colors.grey600,
    fontSize: '0.875rem',
  },
  textGreyBold: {
    color: colors.grey800,
    fontWeight: 600,
  },
  switchContainer: {
    margin: theme.spacing(0, 1),
  },
  label: {
    fontSize: '14px',
    color: colors.grey800,
    fontWeight: 'normal',
    lineHeight: '22px',
  },
  collapsible: {
    width: '100%',
    marginTop: '0 !important',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '0.8rem',
    border: '1px solid #e4e4e8',
    display: 'flex',
    flexDirection: 'column',
  },
  dotLine: {
    border: 'none',
    borderTop: '1px dotted #E0E0E0',
    flex: '1',
    margin: '0 10px',
  },
  backgroundZone: {
    backgroundColor: '#fff',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    padding: theme.spacing(2),
    borderLeft: '1px solid #dbdbe0',
    borderRight: '1px solid #dbdbe0',
    borderBottom: '1px solid #dbdbe0',
  },
  containerZone: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
  zoneNotConfig: {
    color: colors.error,
    fontSize: '0.8rem',
  },
}));

export default function LogisticsShippingAdvanced() {
  const classes = useStyles();
  const location = useLocation();

  const [addresses, setAddresses] = useState();
  const [tabValue, setTabValue] = useState('national');
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const [filterModal, setFilterModal] = useState({});
  const {availableShippingCountries} = useFetchShippingMethods();
  const country = useStoreCountry();
  const {shippingDataAdvanced} = useDataShippingAdvanced();
  const {
    savingShippingSuccess,
    isSaving,
    updateAllowOrdersOutsideDeliveryZone,
  } = useAllowOrdersOutsideDeliveryZone();
  const {resetState} = useResetState();
  const countries = useCountries();
  const {register} = useForm();

  const isCountryAvailable = countryCode => {
    return availableShippingCountries.some(
      country => country.code === countryCode
    );
  };

  const handleFilter = filter => {
    setFilterModal(filter);
  };

  const handleCloseModal = () => {
    setOpenModalFilter(false);
  };

  const handleAllowOrdersOutsideDeliveryZone = e => {
    const updateOutsideShippingRequest = {
      storeShippingMethodAdvancedSetting: {
        enabledAdminOutsideShipping: e.target.checked,
      },
    };
    updateAllowOrdersOutsideDeliveryZone(updateOutsideShippingRequest);
  };

  const passesFilter = (rate, filter) => {
    if (!filter || Object.keys(filter).length === 0) {
      return true;
    }

    if (!rate) {
      return false;
    }

    const countryCode = filter.countryCode;
    let countryLocation;

    if (tabValue === 'national') {
      if (!rate.location || !rate.location[country.code]) {
        return false;
      }
      countryLocation = rate.location[country.code];
    } else if (rate[countryCode]) {
      const addresses = rate[countryCode].addresses;
      if (
        !addresses ||
        !addresses[0].location ||
        !addresses[0].location[countryCode]
      ) {
        return false;
      }
      countryLocation = addresses[0].location[countryCode];
    }

    if (!countryLocation) {
      return false;
    }

    const checkAdminLevel = (location, adminIds) => {
      let currentLocation = location;

      for (const adminId of adminIds) {
        if (typeof currentLocation === 'boolean') {
          return true;
        }

        if (!currentLocation || !currentLocation[adminId]) {
          return false;
        }

        currentLocation = currentLocation[adminId];
      }

      return true;
    };

    const adminIds = [];
    if (filter.admin1 && filter.admin1.adminId != null) {
      adminIds.push(filter.admin1.adminId);
    }
    if (filter.admin2 && filter.admin2.adminId != null) {
      adminIds.push(filter.admin2.adminId);
    }
    if (filter.admin3 && filter.admin3.adminId != null) {
      adminIds.push(filter.admin3.adminId);
    }

    if (adminIds.length > 0 && !checkAdminLevel(countryLocation, adminIds)) {
      return false;
    }

    return true;
  };

  const isAvailableOtherCountries =
    availableShippingCountries &&
    availableShippingCountries.filter(
      countryI => countryI?.code !== country?.code
    ).length > 0;

  const subRoutes: {[key: string]: SubRoute} = useMemo(
    () => ({
      national: {
        name: 'Nueva tarifa nacional',
        path: '/configure/logistics/shipping/advanced/national/new',
        component: LogisticsShippingNewAdvancedNational,
        id: 'advanced-shipping-national',
        id2: 'advanced-shipping-configuration',
      },
      international: {
        name: 'Nueva tarifa internacional',
        path: '/configure/logistics/shipping/advanced/international/new',
        component: LogisticsShippingNewAdvancedInternational,
        id: 'advanced-shipping-international',
        id2: 'advanced-shipping-configuration',
      },
    }),
    []
  );

  const subRoutesArray = Object.keys(subRoutes)
    .map(k => subRoutes[k])
    .filter((route: SubRoute) => !route.hide);

  const subRoute: ?SubRoute = subRoutesArray.find(
    (route: SubRoute) => location.pathname === route.path
  );

  useEffect(() => {
    const totalAddress = {
      national: [],
      international: [],
    };

    if (
      shippingDataAdvanced &&
      country &&
      shippingDataAdvanced.storeShippingMethodAdvancedAdminGroups
    ) {
      shippingDataAdvanced.storeShippingMethodAdvancedAdminGroups.forEach(
        shippingAdvanced => {
          const locationKeys = Object.keys(shippingAdvanced.location || {});
          locationKeys.forEach(locationKey => {
            const countryCode = locationKey;

            if (countryCode === country.code) {
              totalAddress.national.push(shippingAdvanced);
            } else {
              shippingAdvanced.countryCode = countryCode;
              const existingLocation = totalAddress.international.find(
                item => item[countryCode]
              );
              if (existingLocation) {
                existingLocation[countryCode].addresses.push(shippingAdvanced);
              } else {
                const newLocation = {};
                newLocation[countryCode] = {
                  addresses: [shippingAdvanced],
                };
                totalAddress.international.push(newLocation);
              }
            }
          });
        }
      );
    }

    setAddresses(totalAddress);
  }, [countries, country, shippingDataAdvanced]);

  useEffect(() => {
    if (savingShippingSuccess) {
      resetState();
    }
  }, [resetState, savingShippingSuccess]);

  useEffect(() => {
    return () => {
      resetState();
    };
  }, [resetState]);

  const allNationalRatesAreDisabled = useMemo(() => {
    if (!addresses) return true;

    if (addresses.national.length === 0) return false;

    return addresses.national.every(rate => !rate.enabled);
  }, [addresses]);

  return (
    <>
      <div className={classes.root}>
        {subRoute && (
          <>
            <div className={classes.subRouteHeader}>
              <IconButton
                variant="contained"
                size="small"
                component={Link}
                to={`/configure/logistics/shipping/advanced${window.location.search}`}
              >
                <ArrowBack />
              </IconButton>
              <Typography className={classes.subRouteTitle} id={subRoute.id2}>
                {subRoute.name}
              </Typography>
            </div>
            <Divider className={classes.divider} />
          </>
        )}

        <Switch>
          <Route exact path="/configure/logistics/shipping/advanced">
            {/* <Divider className={classes.divider} /> */}
            <div className={classes.backgroundZone}>
              <Typography className={classes.textZone}>
                Define las zonas de reparto
              </Typography>
              <div className={classes.contentBackground}>
                <div className={classes.contentTabs}>
                  <Tabs
                    value={tabValue}
                    onChange={(event, newValue) => {
                      setTabValue(newValue);
                      setFilterModal({});
                    }}
                    aria-label=""
                    className={classes.tabs}
                    variant="fullWidth"
                    indicatorColor="primary"
                  >
                    <Tab
                      className={`${classes.tabButton} ${
                        tabValue === 'national' ? classes.tabSelected : ''
                      }`}
                      value="national"
                      label="Nacionales"
                    />
                    <Tab
                      disabled={!isAvailableOtherCountries}
                      className={`${classes.tabButton} ${
                        tabValue === 'international' ? classes.tabSelected : ''
                      }`}
                      value="international"
                      label="Internacionales"
                    />
                  </Tabs>

                  <div className={classes.buttonsHeader}>
                    {Object.keys(filterModal).length > 0 && (
                      <CustomButton
                        className={classes.filterButton}
                        color="default"
                        startIcon={<Close />}
                        onClick={() => setFilterModal({})}
                      >
                        Borrar filtros
                      </CustomButton>
                    )}

                    <CustomButton
                      className={classes.filterButton}
                      color="default"
                      startIcon={<Tune />}
                      onClick={() => setOpenModalFilter(true)}
                    >
                      Filtros
                    </CustomButton>
                  </div>
                </div>

                <Divider className={classes.divider} />

                <div className={classes.container}>
                  <div className={classes.container}>
                    {tabValue === 'national' && allNationalRatesAreDisabled && (
                      <div>
                        <Alert severity="error">
                          Debes tener al menos una tarifa nacional activa, para
                          poder recibir pedidos.
                        </Alert>
                      </div>
                    )}
                    {tabValue === 'national' && (
                      <div className={classes.containerCollapsible}>
                        {addresses &&
                          addresses?.national
                            .filter(rate => passesFilter(rate, filterModal))
                            .map((rate: ShippingAdvancedRate) => {
                              return (
                                <CollapsibleAdvancedShipping
                                  rate={rate}
                                  classes={classes}
                                  key={`key-${rate.id}`}
                                  isNational={true}
                                  isEditable={true}
                                />
                              );
                            })}
                      </div>
                    )}

                    {tabValue === 'international' && (
                      <div className={classes.containerCollapsible}>
                        {addresses &&
                          addresses?.international
                            .filter(rate => passesFilter(rate, filterModal))
                            .map((data, index) => {
                              const countryCode = Object.keys(data)[0];
                              const countryData = data[countryCode];
                              const countryName = countries.find(
                                country => country.code === countryCode
                              )?.name;

                              return (
                                <React.Fragment key={`${countryCode}-${index}`}>
                                  <div className={classes.containerZone}>
                                    <Chip
                                      label={countryName}
                                      className={
                                        isCountryAvailable(countryCode)
                                          ? classes.chipCountry
                                          : classes.chipCountryNotFound
                                      }
                                    />
                                    {!isCountryAvailable(countryCode) && (
                                      <Typography
                                        className={classes.zoneNotConfig}
                                      >
                                        Esta zona de reparto no está configurada
                                      </Typography>
                                    )}
                                  </div>
                                  {countryData.addresses.map(rate => (
                                    <CollapsibleAdvancedShipping
                                      rate={rate}
                                      classes={classes}
                                      key={rate.id}
                                      isNational={false}
                                      isEditable={isCountryAvailable(
                                        countryCode
                                      )}
                                    />
                                  ))}
                                </React.Fragment>
                              );
                            })}
                      </div>
                    )}
                  </div>

                  <CustomButton
                    classes={{
                      root: classes.newRate,
                    }}
                    color="default"
                    startIcon={
                      <div className={classes.backgroundButton}>
                        <Add />
                      </div>
                    }
                    to={
                      tabValue === 'national'
                        ? `/configure/logistics/shipping/advanced/national/new`
                        : `/configure/logistics/shipping/advanced/international/new`
                    }
                    // disabled={isSaving || !enabled || hasShippingMethodFeatureDisabled}
                  >
                    Crear nueva tarifa
                  </CustomButton>
                </div>
              </div>
            </div>
            <div className={classes.delivery}>
              <div className={classes.containerHeaderDelivery}>
                <Typography className={classes.headerDelivery}>
                  Permitir ordenes fuera de la zona de delivery
                </Typography>
                <FormControlLabel
                  control={
                    <IosSwitch
                      onChange={e => handleAllowOrdersOutsideDeliveryZone(e)}
                      disabled={isSaving}
                      checked={
                        (shippingDataAdvanced &&
                          shippingDataAdvanced.enabledAdminOutsideShipping) ||
                        false
                      }
                      className={classes.switchContainer}
                      name="enabledIdentificationNumber"
                      inputRef={register()}
                    />
                  }
                  labelPlacement="start"
                  label={<div className={classes.label}>Activado</div>}
                />
              </div>
              <Divider className={classes.divider} />

              <Typography className={classes.textGrey2}>
                Todas las órdenes fuera de zona de envío tendrán la siguiente
                configuración:
              </Typography>
              <div>
                <Typography className={classes.textGrey2}>
                  Costo delivery: Por confirmar
                </Typography>
                <Typography className={classes.textGrey2}>
                  Método de pago: Pedir por WhatsApp
                </Typography>
              </div>
              <Typography className={classes.textGrey2}>
                Y tú deberás hacerle llegar el costo de envío correspondiente
                para el cálculo de total a pagar.
              </Typography>
            </div>
          </Route>
          {subRoutesArray.map((route: SubRoute, idx: number) => (
            <Route key={idx} path={route.path} component={route.component} />
          ))}

          <Route path="/configure/logistics/shipping/advanced/national/:adminRateId">
            <div className={classes.subRouteHeader}>
              <IconButton
                variant="contained"
                size="small"
                component={Link}
                to={`/configure/logistics/shipping/advanced${window.location.search}`}
              >
                <ArrowBack />
              </IconButton>
              <Typography className={classes.subRouteTitle}>
                {tabValue === 'national'
                  ? 'Editar tarifa nacional'
                  : 'Editar tarifa internacional'}
              </Typography>
            </div>
            <Divider className={classes.divider} />
            <LogisticsShippingNewAdvancedNational />
          </Route>
          <Route path="/configure/logistics/shipping/advanced/international/:adminRateId">
            <div className={classes.subRouteHeader}>
              <IconButton
                variant="contained"
                size="small"
                component={Link}
                to={`/configure/logistics/shipping/advanced${window.location.search}`}
              >
                <ArrowBack />
              </IconButton>
              <Typography className={classes.subRouteTitle}>
                {tabValue === 'national'
                  ? 'Editar tarifa nacional'
                  : 'Editar tarifa internacional'}
              </Typography>
            </div>
            <Divider className={classes.divider} />
            <LogisticsShippingNewAdvancedInternational />
          </Route>
        </Switch>
      </div>

      <FilterModalShipping
        typeFilter={tabValue}
        open={openModalFilter}
        handleCloseModal={handleCloseModal}
        handleFilter={handleFilter}
        showAdmin3={false}
        availableShippingCountries={availableShippingCountries}
        ignoreStoreCountryP={tabValue === 'international' ? true : false}
        filterIsEmpty={Object.keys(filterModal).length === 0}
      />
    </>
  );
}
